import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../api-authorization/authorize.service';
import { DataService } from '../data.service';
import { Element } from '../../element.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  isExpanded = false;
  isAuthenticated = false;
  emptyElements: Element[] = [];
  lowStockElements: Element[] = [];
  isLoadingStock = false;

  constructor(
    private router: Router,
    public authService: AuthService,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.isAuthenticated = this.authService.isAuthenticated();
    // Der reine Vorarbeiter landet direkt im Ticketsystem (sieht nur Lager + Einsätze).
    if (this.isAuthenticated && this.authService.isFieldVorarbeiter()) {
      this.router.navigate(['/stammkunden/meine-einsaetze']);
      return;
    }
    if (this.isAuthenticated) {
      this.loadLowStockElements();
    }
  }

  loadLowStockElements(): void {
    this.isLoadingStock = true;
    // Load first 200 elements sorted by quantity ascending to find empty/low stock
    this.dataService.getElementePaged(1, 200, null, null, null, null, null, 'quantity', 'asc')
      .subscribe({
        next: (result) => {
          const allItems = result.items || [];
          this.emptyElements = allItems.filter(e => e.quantity <= 0);
          this.lowStockElements = allItems.filter(e => e.quantity > 0 && e.quantity <= 5);
          this.isLoadingStock = false;
        },
        error: () => {
          this.isLoadingStock = false;
        }
      });
  }

  login() {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/home']);
    } else {
      this.router.navigate(['/users/login']);
    }
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  goToLager() {
    this.router.navigate(['/elemente-liste']);
  }
  goToWartung() {
    this.router.navigate(['/wartung']);
  }
  goToBerichte() {
    this.router.navigate(['/berichte']);
  }
}
